import angular from 'angular';
import myPaymentsDetailComponent from './my-payments-detail.component';
import MyPaymentsDetailService from './my-payments-detail.service';
import myPaymentsDetailConfig from './my-payments-detail.config';

let myPaymentsDetailModule = angular.module('app.payZone.myPaymentsDetail',[])
  .component('myPaymentsDetail', myPaymentsDetailComponent)
  .service('MyPaymentsDetailService', MyPaymentsDetailService)
  .config(myPaymentsDetailConfig);

export default myPaymentsDetailModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/my-payments/my-payments-detail/my-payments-detail.js
 **/